import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"

/**
 * Garde route espace « Mes factures » (DEV-714).
 *
 * Double condition : module `analyse-facture` (Stripe) ACTIF **et** utilisateur
 * ADMINISTRATEUR de son entreprise (R4 — `isCompanyAdmin` = administrateur/owner).
 * Garde d'UX uniquement : l'autorité reste api-metier (`companyAdminOnly` sur
 * `/v5/energyinvoices*`). Sinon redirection vers l'accueil.
 */
export async function beforeEnterMesFactures(
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> {
    const authStore = useAuthStore()
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
    if (authStore.hasModuleAnalyseFacture && authStore.isCompanyAdmin) {
        next()
    } else {
        next({ name: "PageHomeBuildings" })
    }
}
